import POSListViewModel from "../view/poslistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedPOS extends PagedElements<POSListViewModel> {
    constructor(init?: Partial<PagedPOS>) { super(init); }
}